import { ScrollOverflowEnum } from './constants';
const calculateOverflow = (scrollWidth, scrollLeft, scrollContainerWidth) => {
    const hasScroll = scrollWidth > scrollContainerWidth;
    const hasLeftOffset = hasScroll && scrollLeft > 0;
    const hasRightOffset = hasScroll && scrollLeft < scrollWidth - scrollContainerWidth;
    if (hasLeftOffset && hasRightOffset) {
        return ScrollOverflowEnum.BOTH;
    }
    if (hasLeftOffset) {
        return ScrollOverflowEnum.LEFT;
    }
    if (hasRightOffset) {
        return ScrollOverflowEnum.RIGHT;
    }
    return ScrollOverflowEnum.NONE;
};
export default calculateOverflow;
